import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import VisibilityToggle from '../../../components/Editor/VisibilityToggle';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: { spreadZoom, isAccessibleVersion },
	} = state;

	return {
		spreadZoom,
		isAccessibleVersion,
	};
};

export default connect(mapStateToProps)(VisibilityToggle);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/VisibilityToggle/index.tsx